import { render, staticRenderFns } from "./MedicineReportMethod.vue?vue&type=template&id=055f4e61"
import script from "./MedicineReportMethod.vue?vue&type=script&lang=js"
export * from "./MedicineReportMethod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports